import request from "@/utils/request";
// const baseUrl = "http://127.0.0.1:3000";
const baseUrl = "https://services.shdyt.net.cn";

// 查出所有菜单
export function getMenu(params= {}) {
    return request({
        method: 'get',
        url: baseUrl + '/api/cd/cdMenu/show/search',
        params 
    })
}

// list
export function getMenuList(params= {}) {
    return request({
        method: 'get',
        url: baseUrl + '/api/cd/cdMenu/search',
        params 
    })
}


// get weather
export function getWeather(params = {}) {
    return request({
        method: 'get',
        url: baseUrl + '/api/cd/cdWeather/search',
        params 
    })
}

// POST
// export function login(data) {
//     return request({
//         method: 'post',
//         url: baseUrl + '/business/login',
//         data: data //可以简写为data
//     })
// }